import React, { useState } from 'react'
import SpinnerController from '../spinnerController/Spinner';
import Cookies from 'js-cookie'
import { GoogleLogin,GoogleOAuthProvider } from '@react-oauth/google';
import useAuth from '../../hooks/useAuth';
import axios from '../../api/axios';
import { useNavigate, useLocation, Navigate } from 'react-router-dom';
const LOGIN_URL = '/auth';

const Login = () => {
    const [isLoading, setIsLoading] = useState(false)
    const { auth, setAuth } = useAuth(); 
    const navigate = useNavigate();
    const location = useLocation();
    const from = location.state?.from?.pathname || "/ticket";
    const [error, setError] = useState(false)

    const handleFailure = () => {
      setError("Login failed")
    };
    
    
    const handleLogin = async (googleData) => {
      setIsLoading(true)
        try{
            const response = await axios.post(
                LOGIN_URL,JSON.stringify({
                    gydaToken: googleData.credential,
                    }),
                            {
                                headers: {
                                    'Content-Type': 'application/json'
                                },
                                
                                withCredentials: true
                            })
            if(response?.data?.msg) {
              setIsLoading(false)
              return setError(response?.data?.msg) 
            }
            const accessToken = response?.data?.accessToken;
            const isAdmin = response?.data?.isAdmin;
            const email = response?.data?.email;
            const username = response?.data?.username;
            const userLimits = response?.data?.userLimits;
            const title = response?.data?.title;
            Cookies.set('gjwt', googleData.credential)
            setAuth({accessToken, isAdmin, email, username, userLimits, title})
            navigate(from, { replace: true });  
        }catch(err){
            setIsLoading(false)
            return setError("Authentication failed") 

        }
    }
    

  return (
    <div className="h-full w-full py-16 px-4">
      <div className="flex flex-col items-center justify-center">
      <a href="#" className="flex items-center mb-6 text-2xl font-semibold text-gray-900 dark:text-white">
          <img src="assets/animatedLogo.svg" alt="logo" className='h-10'/>
      </a>
      {auth.username ? (
                   <Navigate to="/ticket" state={{from: location}} replace /> 
                ):(
                  <>
                  <div className="p-5 flex justify-center">
                      <GoogleOAuthProvider clientId={"63171592108-4vfvh6i78eqc1m0i3jp7v4kl36valt8f.apps.googleusercontent.com"}>
                          <GoogleLogin
                          text = "signin_with"
                          onSuccess={handleLogin}
                          onError={handleFailure}
                          target="_self"
                          theme="filled_black" 
                          shape="pill"
                          size="large"
                          ux_mode="popup"
                          />
                          {/* rectangular | pill | circle | square */}
                      </GoogleOAuthProvider>
                  </div>
                  <div className="p-2 flex justify-center">
                      {isLoading ? (
                        <SpinnerController/>
                      ):
                      (error !== false && (
                        <p className='text-sm text-red-600'>{error}</p>
                      ))}
                  </div>
                  </>
                )}
      </div>
  </div>
  )
}

export default Login